export default __webpack_public_path__ + "static/media/1.f0ba58c3.jpg";